module.exports = __webpack_public_path__ + "media/images/bus/remove-4692ec19f7cc3364cc1ebb2b9727030e.svg";